import PptxGenJS from "pptxgenjs";

export const slide7 = (pptx: PptxGenJS, data: any) => {
    const slide = pptx.addSlide();
    const reportData = data?.data;
    const combinedQuestions = reportData?.participantReport?.combinedQuestions || (Array.isArray(reportData) ? reportData : []);

    if (!combinedQuestions || combinedQuestions.length === 0) return;

    // Filter out comments and invalid scores
    const behaviors = combinedQuestions.filter((q: any) => q.tag !== "Comments" && q.my_score !== null);

    const processedBehaviors = behaviors.map((q: any) => {
        let totalScore = 0;
        let totalRaters = 0;
        q.raters.forEach((r: any) => {
            totalScore += r.avg_score * r.rater_count;
            totalRaters += r.rater_count;
        });
        const avgRaterScore = totalRaters > 0 ? totalScore / totalRaters : 0;
        const gap = avgRaterScore - q.my_score;

        return {
            behavior: q.text,
            competency: q.tag,
            gap: gap
        };
    });

    // 4. HIDDEN DEVELOPMENT NEEDS: Top 3 by negative gap (Raters < Self)
    const hiddenDevNeeds = [...processedBehaviors]
        .filter(b => b.gap < 0)
        .sort((a, b) => a.gap - b.gap)
        .slice(0, 3)
        .map(b => ({ behavior: b.behavior, competency: b.gap < 0 ? b.competency : '' }));
    // Wait, the map above is slightly weird if gap >= 0 but filter handles it.

    // Logo
    slide.addImage({
        path: '/Access-Holdings-Logo.jpg',
        x: 0.5,
        y: 0.2,
        w: 1.3,
        h: 0.45
    });

    // Page Title
    slide.addText("Your Strengths and Development Needs Cont’d", {
        x: 0.5,
        y: 0.8,
        w: 7.27,
        h: 0.5,
        fontSize: 20,
        bold: true,
        color: '000000'
    });

    // Section Title
    slide.addText([
        { text: "HIDDEN ", options: { fontSize: 12, bold: true, color: '404040' } },
        { text: "DEVELOPMENT NEEDS", options: { fontSize: 12, bold: true, color: 'FF6600' } }
    ], {
        x: 0.5,
        y: 1.5,
        w: 7.27,
        h: 0.4
    });

    // Subtitle
    slide.addText("(These behaviors had the greatest NEGATIVE gap between your raters' score and your score.)", {
        x: 0.5,
        y: 1.9,
        w: 7.27,
        h: 0.3,
        fontSize: 10,
        color: '595959'
    });

    // Table
    const tableTop = 2.4;
    const colW = [4.5, 2.77];
    const headerH = 0.4;
    const rowH = 0.6;

    // Table Header Background
    slide.addShape('rect', { x: 0.5, y: tableTop, w: colW[0], h: headerH, fill: { color: 'EAEAEA' }, line: { color: '404040', width: 1 } });
    slide.addShape('rect', { x: 0.5 + colW[0], y: tableTop, w: colW[1], h: headerH, fill: { color: 'EAEAEA' }, line: { color: '404040', width: 1 } });

    // Header Text
    slide.addText("BEHAVIORS", { x: 0.6, y: tableTop, w: colW[0] - 0.2, h: headerH, fontSize: 10, bold: true, valign: 'middle' });
    slide.addText("COMPETENCY (DOMAIN)", { x: 0.5 + colW[0] + 0.1, y: tableTop, w: colW[1] - 0.2, h: headerH, fontSize: 10, bold: true, valign: 'middle' });

    // Rows
    hiddenDevNeeds.forEach((r, i) => {
        const y = tableTop + headerH + (i * rowH);
        slide.addShape('rect', { x: 0.5, y: y, w: colW[0], h: rowH, line: { color: '404040', width: 1 } });
        slide.addShape('rect', { x: 0.5 + colW[0], y: y, w: colW[1], h: rowH, line: { color: '404040', width: 1 } });

        slide.addText(r.behavior, { x: 0.6, y: y, w: colW[0] - 0.2, h: rowH, fontSize: 9, color: '404040', valign: 'middle' });
        slide.addText(r.competency, { x: 0.5 + colW[0] + 0.1, y: y, w: colW[1] - 0.2, h: rowH, fontSize: 9, color: '404040', valign: 'middle' });
    });

    // Footer
    const candidateName = data?.candidateName || 'Jane Doe';
    slide.addText(`360-Degree Feedback Individual Report for ${candidateName}`, {
        x: 0,
        y: 11.2,
        w: 7.8,
        h: 0.3,
        fontSize: 9,
        color: '666666',
        align: 'center'
    });

    // slide.addText("7", {
    //     x: 7.8,
    //     y: 11.2,
    //     w: 0.4,
    //     h: 0.3,
    //     fontSize: 9,
    //     color: '666666',
    //     align: 'center'
    // });
};
